export const ossUrl = "https://jrready-cdn.oss-cn-hangzhou.aliyuncs.com/";
